import { empty, template } from './utils'
// // UI Config
const MIN_HEIGHT = 130
const MAX_HEIGHT = 1280
const HANDLE_HEIGHT = 50
const F = 1.15
const F_BIG = 1.65

const CONTINENTS = {
  Europe: [[69.75588471422357, 94.57829046831353], [34.542118027938166, -37.081865781686474]],
  Asia: [[65.00286627252551, -169.40057630765136], [-10.303448877226767, 20.267392442348637]],
  'North America': [[67.42893170648608, -45.81310168750002], [9.15723396094267, -175.62755481250002]],
  'South America': [[18.914353248240836, 1.2455381159952594], [-60.963637450756096, -137.62164938400474]],
}

class SGMap {
  constructor(pois, mapType, mapSel, infoWinTemplate) {
    this.isInit = false
    this.delayUntilInit = {}
    this.delayCounter = 0

    let self = this

    const delay = function(f) {
      const ff = function() {
        var args = Array.prototype.slice.call(arguments)

        if (self.isInit) {
          f.apply(self, args)
        } else {
          self.delayUntilInit[ff.__id__] = [ff, args]
        }
      }
      ff.__id__ = self.delayCounter++

      return ff
    }

    this.openWindowForLocationID = delay(this.openWindowForLocationID)

    this.pois = pois
    this.mapType = mapType
    this.mapSel = mapSel
    this.infoWinTemplate = infoWinTemplate

    if (mapType == 'recruiting') {
      this.markerIconUrls = window.saargummiVars.map.markerIconUrls.recruiting
    } else {
      this.markerIconUrls = window.saargummiVars.map.markerIconUrls.locations
    }

    this.markers = []

    if (this.googleIsLoaded()) {
      this.initMap()
    } else {
      $(window).on('googleMapsLoaded', () => {
        // debugger
        this.initMap()
      })
    }
  }

  googleIsLoaded() {
    return 'google' in window
  }

  openWindowForLocationID(locationId) {
    const m = this.markers.find((m) => m.locationId == locationId)
    if (m) {
      m.infoWin.open()
    }
  }

  initMap() {
    this.showMap()
    this.addMarkers(this.pois)

    this.isInit = true

    const d = this.delayUntilInit
    const self = this

    Object.keys(d).forEach((fid) => {
      const [ff, args] = d[fid]
      ff.apply(self, args)
    })
    // this.delayUntilInit.map((f) => )
    // f = => this.mapDidLoadCallbacks.forEach((cb)=> cb.call(this.))
    // setTimeout(f, 10)
  }

  setAreas(areas) {
    this.areas = areas
    if (this.googleIsLoaded()) {
      this.showAreas()
    } else {
      $(window).on(
        'googleMapsLoaded',
        function() {
          this.showAreas()
        }.bind(this)
      )
    }
  }

  showAreas() {
    const areas = this.areas
    for (let i = 0; i < areas.length; i++) {
      const coords = []
      const crds = areas[i].coords.split(',')
      for (let j = 0; j < crds.length; j += 2) {
        coords.push({ lat: parseFloat(crds[j + 1]), lng: parseFloat(crds[j]) })
      }
      // close
      coords.push({ lat: parseFloat(crds[1]), lng: parseFloat(crds[0]) })

      var polygon = new google.maps.Polygon({
        paths: coords,
        strokeColor: '#7cb046',
        strokeOpacity: 0.8,
        strokeWeight: 3,
        fillColor: '#7cb04600',
        fillOpacity: 0.35,
      })
      polygon.contactAreaId = areas[i].id

      polygon.setMap(this.map)
      const infoWin = this.contactAreaInfoWin(polygon, areas[i])
      polygon.infoWin = infoWin

      // Add a listener for the click event.
      google.maps.event.addListener(polygon, 'click', function(e) {
        infoWin.setPosition(e.latLng)
        const contactAreaId = this.contactAreaId
        // load data
        $('body').trigger('SGMap.contactAreaInfoWinOpen', { contactAreaId })
      })

      google.maps.event.addListener(polygon, 'mouseover', function() {
        this.setOptions({ fillColor: '#7cb046' })
      })

      google.maps.event.addListener(polygon, 'mouseout', function() {
        this.setOptions({ fillColor: '#7cb04600' })
      })
    }
  }

  contactAreaInfoWin(polygon, area) {
    const boxText = document.createElement('div')

    const tempLoc = Object.assign({}, area, {
      onClick: `$('body').trigger('SGMap.filterByAreaID', ${area.id});void(0)`,
    })

    boxText.innerHTML = template(tempLoc, this.infoWinTemplate)

    return new SnazzyInfoWindow({
      content: boxText,
      closeOnMapClick: false,
      marker: polygon,
      position: new google.maps.LatLng(49.44424449862623, 12.29489510556647),
      placement: top,
      offset: {
        top: '-8px',
        left: '0px',
      },
      edgeOffset: {
        top: 20, // For the mobile map! (was 120)
        right: 20,
        bottom: 20,
        left: 20,
      },
      closeWhenOthersOpen: true,
    })
  }

  showMap() {
    const mapDiv = $(this.mapSel).get(0)
    const config = window.saargummiVars.map
    this.map = new google.maps.Map(mapDiv, {
      center: new google.maps.LatLng(parseFloat(config.lat, 10), parseFloat(config.lng, 10)),
      fullscreenControl: false,
      zoom: parseInt(config.zoom, 10),
      zoomControlOptions: {
        style: google.maps.ZoomControlStyle.SMALL,
        position: google.maps.ControlPosition.RIGHT_TOP,
      },
      mapTypeControl: false,
      mapTypeId: google.maps.MapTypeId.ROADMAP,
      navigationControl: true,
      overviewMapControl: false,
      panControl: false,
      streetViewControl: false,
      scrollwheel: false,
      // Note: Create styles at
      // https://mapstyle.withgoogle.com/ or download presets from https://snazzymaps.com/.
      styles: window.GMapCustomStyle,
    })
    // window.map = this.map

    // Center map on window resize.
    // See: http://stackoverflow.com/questions/8792676/center-google-maps-v3-on-browser-resize-responsive.
    google.maps.event.addDomListener(window, 'resize', () => this.centerMap())

    this.setZoomControlPosition()
  }
  setZoomControlPosition() {
    if ($(window).width() < 990) {
      this.map.set('zoomControlOptions', { style: 1, position: 9 })
    } else {
      this.map.set('zoomControlOptions', { style: 1, position: 7 })
    }
  }

  centerMap() {
    const center = this.map.getCenter()
    google.maps.event.trigger(this.map, 'resize')
    this.map.setCenter(center)
  }

  addMarkers(pois) {
    pois.forEach((loc, i) => {
      this.renderMarker(loc, i, pois.length)
    })
    this.zoomToMarkers(pois)
  }

  zoomToMarkers(pois) {
    if (pois.length === 0) {
      return
    }

    // Adjust map to fit all markers.
    if (pois.length === 1) {
      this.map.setZoom(11)
      this.map.setCenter(new google.maps.LatLng(pois[0].lat - 0, pois[0].lon - 0))
    } else if (pois.length > 0) {
      //  See: http://blog.shamess.info/2009/09/29/zoom-to-fit-all-markers-on-google-maps-api-v3/
      const bounds = new google.maps.LatLngBounds()

      pois.forEach((location, i) => {
        const pos = new google.maps.LatLng(location.lat - 0, location.lon - 0)
        bounds.extend(pos)
      })
      this.map.initialZoom = true
      this.map.fitBounds(bounds)
    }
  }

  zoomToContinent(continent) {
    if (empty(continent)) {
      debugger
    }

    const bounds = new google.maps.LatLngBounds()
    for (coords in CONTINENTS[continent]) {
      const pos = new google.maps.LatLng(coords[0], coords[1])
      bounds.extend(pos)
    }

    this.map.setZoom(11)
    this.map.initialZoom = true
    this.map.fitBounds(bounds)
    this.map.setCenter(bounds.getCenter())
  }

  iconForLocation(location) {
    return this.markerIconUrls[location.divisionEn.toString().toLowerCase()]
  }

  renderMarker(location, idx, num) {
    const iconObj = {
      url: this.iconForLocation(location),
      scaledSize: new google.maps.Size(24 * F, 35 * F),
      origin: new google.maps.Point(0, 0),
      anchor: new google.maps.Point(12 * F, 35 * F),
    }

    const marker = new google.maps.Marker({
      position: {
        lat: parseFloat(location.lat),
        lng: parseFloat(location.lon),
      },
      map: this.map,
      title: location.name,
      icon: iconObj,
      id: location.id,
      locationId: location.id,
      zIndex: idx,
      orgZIndex: idx,
    })

    const self = this
    marker.addListener('mouseover', function() {
      self.scaleMarker(this, true)
    })

    marker.addListener('mouseout', function() {
      self.scaleMarker(this, false)
    })

    marker.addListener('click', function(e) {
      $('body').trigger('SGMap.markerClicked', { locationId: location.id })
    })

    marker.infoWin = this.infoWin(marker, location)
    this.markers.push(marker)
  }

  infoWin(marker, location) {
    const boxText = document.createElement('div')
    const address = location.address.replace(/(?:\r\n|\r|\n)/g, '<br />')

    const tempLoc = Object.assign(
      {},
      location,
      { address: `${address} <br/> ${location.countryName}` },
      { onClick: `$('body').trigger('SGMap.filterByloctionID', ${location.id});void(0)` }
    )

    boxText.innerHTML = template(tempLoc, this.infoWinTemplate)

    return new SnazzyInfoWindow({
      content: boxText,
      closeOnMapClick: false,
      marker: marker,
      placement: top,
      offset: {
        top: '-40px',
        left: '0px',
      },
      edgeOffset: {
        top: 20, // For the mobile map! (was 120)
        right: 20,
        bottom: 20,
        left: 20,
      },
      closeWhenOthersOpen: true,
    })
  }

  scaleMarker(m, big = true) {
    if (empty(m)) {
      return
    }
    const icon = m.getIcon()

    const f = big ? F_BIG : F

    icon.scaledSize = new google.maps.Size(24 * f, 35 * f)
    icon.size = icon.scaledSize
    icon.anchor = new google.maps.Point(12 * f, 35 * f)
    if (big) {
      m.zIndex = 10000
    } else {
      m.zIndex = m.orgZIndex
    }
    m.setIcon(icon)
  }
}

export default SGMap



// WEBPACK FOOTER //
// app/javascript/sg/js/SGMap.js